<div data-testid="delete-adx-booking-udid-dialog-confirmpopup" class="confirmpopup">
    <div data-testid="-delete-adx-booking-udid-dialog-dialog-title" mat-dialog-title>
      <label data-testid="delete-adx-booking-udi-ddialog-title-label" class="title">Delete Udid</label>
    </div>
    <hr data-testid="delete-adx-booking-udid-dialog-first-hr">
    <div data-testid="delete-adx-booking-udid-dialog-dialog-content" mat-dialog-content>
      <p data-testid="delete-adx-booking-udid-dialog-content-p">Are you sure you want to delete this udid?</p>
      <p data-testid="delete-adx-booking-udid-dialog-content-p2"><b>You still need to click on Update to apply the change.</b></p>
    </div>
    <hr data-testid="delete-adx-booking-udid-dialog-second-hr">
    <div data-testid="delete-adx-booking-udid-dialog-dialog-actions" mat-dialog-actions style="float: right;">
      <button data-testid="delete-adx-booking-udid-dialog-ok-button" mat-raised-button (click)="okClick()" color="primary"
        type="submit" cdkFocusInitial matTooltip="Delete Udid" aria-label="Delete Udid">
        Ok
      </button>
      <button data-testid="delete-adx-booking-udid-dialog-no-button" mat-raised-button (click)="onNoClick()" color="warn">
        No
      </button>
    </div>
  </div>
  